module.exports = __webpack_public_path__ + "img/foreword_2.d198d39f.jpg";